var _rect, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOracleHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 60",
    role: "img",
    "aria-label": "Oracle Health (Cerner)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 238,
    height: 58,
    rx: 10,
    fill: "none",
    stroke: "#cbd5e1",
    strokeWidth: 1.2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 27,
    textAnchor: "middle",
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "#c74634"
  }, "ORACLE")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 47,
    textAnchor: "middle",
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 500,
    fill: "#334155",
    letterSpacing: 1.5
  }, "HEALTH \xB7 CERNER")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOracleHealth);
export default __webpack_public_path__ + "static/media/oracle-health.1b5317719a72b72c75c27cc2d80e54f6.svg";
export { ForwardRef as ReactComponent };